<template>
  <div class="p-5">
    <div>
      {{ $t('customers.copypaste') }}:
    </div>
    <div class="mt-4">
      <p class="text-sm font-medium text-gray-700">{{ $t('customers.name') }}:</p>
      <input type="text" name="name" v-model="name" class="border border-gray-200 p-2 w-full">
    </div>
    <div class="mt-4">
      <p class="text-sm font-medium text-gray-700">{{ $t('customers.phone') }}:</p>
      <input type="text" name="phone_number" v-model="phoneNumber" class="border border-gray-200 p-2 w-full">
    </div>
    <div class="mt-4">
      <p class="text-sm font-medium text-gray-700">{{ $t('customers.avatarUrl') }}:</p>
      <input type="text" name="avatar" v-model="avatar" class="border border-gray-200 p-2 w-full">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerReadOnlyForm',
  props: ['customer'],
  data() {
    return {
      name: this.customer.attributes.name,
      phoneNumber: this.customer.attributes['phone-number'],
      avatar: this.customer.attributes.avatar,
    }
  },
}
</script>
